import React from 'react'
import CustomAlert from '../../components/shared/CustomAlert/CustomAlert.component'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import {
  MDBCol,
  MDBIcon,
  MDBContainer,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBSpinner,
  MDBModalDialog,
  MDBModalContent,
} from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import { Subscription } from 'rxjs'
import TrainingsPageService from './shared/TrainingsPage.service'
import TrainingList from './components/TrainingList/TrainingList.component'
import TrainingVideoForm from './components/TrainingVideoForm/TrainingVideoForm.component'
import TrainingTypeForm from './components/TrainingTypeForm/TrainingTypeForm.component'
import TrainingValidator from './components/TrainingValidator/TrainingValidator.component'
import TrainingQuiz from './components/TrainingQuiz/TrainingQuiz.component'
import trainingsHeaderImg from './assets/bg.trainings-page.jpg'
import UserProfileService from './../../shared/services/UserProfile.service'
import ActivityStore from '../../shared/stores/activity.store'

import './TrainingsPage.scss'
import TrainingQuizService from '../../shared/services/TrainingQuiz.service'
import TrainingQuestionService from '../../shared/services/TrainingQuestion.service'
import TrainingAnswerService from '../../shared/services/TrainingAnswer.service'
import UserTrainingQuizService from '../../shared/services/UserTrainingQuiz.service'

class VideoInterval {
  #intervalId = null

  clear = () => {
    if (this.#intervalId) clearInterval(this.#intervalId)
    this.#intervalId = null
  }

  start = (callback, timeout) => {
    this.clear()
    if (callback && typeof callback === 'function')
      this.#intervalId = setInterval(callback, parseInt(isNaN(timeout) ? 1000 : timeout))
  }
}

class TrainingsPage extends React.Component {
  state = {
    loading: false,
    submitting: false,
    content: '',
    trainings: [],
    trainingTypes: [],
    trainingLoading: true,
    trainingTypesLoading: true,

    videoUrl: null,
    videoTitle: null,

    training: null,
    trainingType: null,

    canCreate: false,
    canEdit: false,
    canDelete: false,
    inputValue: '',
    requires_quiz: null,
    training_quiz: null,
    training_questions: [],
    training_answers: [],
    training_quiz_loading: false,
    requiredTrainings: null,
  }

  #VideoInterval = null
  #_subscriptions$ = new Subscription()

  // Video modal timer control methods
  #closeVideoModal = () => {
    // Resume inactivity timer when training video modal closes
    if (window.ActivityStore) {
      window.ActivityStore.resumeTimer()
    }
    TrainingsPageService.setViewVideo(null)
  }

  #openVideoModal = () => {
    // Pause inactivity timer when training video modal opens
    if (window.ActivityStore) {
      window.ActivityStore.pauseTimer()
    }
  }

  #resumeTimerOnly = () => {
    // Resume inactivity timer without closing modal (for internal use)
    if (window.ActivityStore) {
      window.ActivityStore.resumeTimer()
    }
  }

  componentDidMount() {
    this.#VideoInterval = new VideoInterval()
    this.#fetchTrainingPageData(11)

    this.#_subscriptions$.add(
      TrainingsPageService.fetchTrainingTypes().subscribe(types => this.#setTrainingTypes(types))
    )
    this.#_subscriptions$.add(
      TrainingsPageService.fetchTrainings().subscribe(trainings => this.#setTrainings(trainings))
    )

    this.#_subscriptions$.add(TrainingsPageService.getViewVideo().subscribe(training => this.#viewVideo(training)))

    if (parseInt(UserProfileService.getCurrentUserTypeId()) !== 91) {
      this.#_subscriptions$.add(TrainingsPageService.getEditVideo().subscribe(training => this.setState({ training })))
      this.#_subscriptions$.add(
        TrainingsPageService.getEditType().subscribe(trainingType => this.setState({ trainingType }))
      )
      this.#_subscriptions$.add(
        TrainingsPageService.getRequiredTrainings().subscribe(requiredTrainings => this.setState({ requiredTrainings }))
      )
      this.#_subscriptions$.add(
        TrainingsPageService.getRequiredTrainings().subscribe(requiredTrainings => this.setState({ requiredTrainings }))
      )

      this.#refreshCompletions()
    }

    this.#checkPermissions()
  }

  #refreshCompletions = () => {
    TrainingsPageService.fetchTrainingAttended()
    TrainingsPageService.fetchRequiredTrainings()
    this.fetchUserTrainingQuizes()
  }

  #openTraining = training => {
    if (!training || !training?.training_link) return
    if (training?.training_output === 'external_link') window.open(training.training_link)
    else TrainingsPageService.setViewVideo(training)
  }

  fetchUserTrainingQuizes = async () => {
    const user_training_quizes = (
      await UserTrainingQuizService.search({
        search: { user_id: UserProfileService.getUserId() },
        pagination: false,
      })
    )?.models
    TrainingsPageService.UserTrainingQuizSubject.next(user_training_quizes)
  }

  componentWillUnmount() {
    this.#_subscriptions$.unsubscribe()
    if (this.#VideoInterval && this.#VideoInterval?.clear) this.#VideoInterval.clear()
  }

  #setTrainings = trainings => {
    let trainingTypes = this.state.trainingTypes
    trainingTypes = Array.isArray(trainingTypes)
      ? trainingTypes.map(type => {
          type.count = trainings.filter(training => parseInt(training.training_type_id) === parseInt(type.id)).length
          return type
        })
      : trainingTypes

    this.setState({
      trainingTypes,
      trainings,
      trainingLoading: !trainings.length,
    })
  }

  #setTrainingTypes = types => {
    types = Array.isArray(types)
      ? types.map(type => {
          type.count = this.state.trainings.filter(
            training => parseInt(training.training_type_id) === parseInt(type.id)
          ).length
          return type
        })
      : types

    this.setState({
      trainingTypes: types,
      loading: !types.length,
      trainingTypesLoading: !types.length,
    })
  }

  #checkPermissions = async () => {
    if (await UserProfileService.canUser(['trainings.create', 'trainings.update', 'trainings.delete']))
      this.setState({ canCreate: true, canEdit: true, canDelete: true })
  }

  #fetchTrainingPageData = async id => {
    this.setState({ loading: true })
    AdminApi.getContentById(id)
      .then(result => {
        if (result && result.data && result.data.data && result.data.data.content)
          this.setState({ content: result.data.data.content || '' })
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  #createVideo = () => (this.state.canCreate ? TrainingsPageService.setEditVideo(true) : {})

  #createType = () => (this.state.canCreate ? TrainingsPageService.setEditType(true) : {})

  #viewVideo = async video => {
    if (video) {
      const link = video.training_link && `${video.training_link}`.replace(/(<([^>]+)>)/gi, '')
      this.setState(
        {
          videoTitle: video.training_name,
          videoUrl: link ? (
            <>
              <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                <iframe
                  src={link}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                  title={video.training_name}
                ></iframe>
              </div>
            </>
          ) : (
            <p className='text-muted mb-0'>No video link available.</p>
          ),
          requires_quiz: video.requires_quiz,
        },
        () => {
          // Pause the inactivity timer when training video starts
          this.#openVideoModal()
        }
      )

      if (video.requires_quiz) {
        this.setState({ training_quiz_loading: true })

        const training_quiz = (
          await TrainingQuizService.search({
            search: { training_id: video.id },
          })
        )?.models[0]
        const training_questions =
          (
            await TrainingQuestionService.search({
              search: { quiz_id: training_quiz?.id },
            })
          )?.models ?? []
        const question_ids = (training_questions || []).map(q => q.id)
        const training_answers =
          (
            await TrainingAnswerService.search({
              search: {
                question_id: question_ids?.length > 0 ? question_ids : null,
              },
            })
          )?.models ?? []

        this.setState({
          training_quiz: training_quiz,
          training_questions: training_questions,
          training_answers: training_answers,
          training_quiz_loading: false,
        })
      }
    } else {
      this.setState({ videoTitle: null, videoUrl: <></> }, () => {
        this.#VideoInterval.clear()
        // Resume the inactivity timer when training video is closed
        this.#resumeTimerOnly()
      })
    }
  }

  render() {
    toast.configure()
    const { loading, content, trainingTypes, trainings, trainingLoading, trainingTypesLoading } = this.state,
      isManager =
        this.state.canCreate ||
        this.state.canEdit ||
        UserProfileService.isA([
          'recruiter-group',
          'system-admin',
          'internal-admin',
          'division-admin',
          'region-admin',
          'district-admin',
        ]),
      showEmpty = this.state.canCreate || this.state.canEdit || this.state.canDelete,
      visibleTypeIds = (trainingTypes && trainingTypes.length ? trainingTypes : [])
        .filter(
          trainingType =>
            (isManager && parseInt(trainingType.is_manager) === 1) || parseInt(trainingType.is_manager) === 0
        )
        .map(trainingType => parseInt(trainingType.id)),
      outstandingRequired = (this.state.requiredTrainings?.trainings || []).filter(
        training => visibleTypeIds.indexOf(parseInt(training.training_type_id)) > -1
      ),
      filteredTrainingTypes = (trainingTypes && trainingTypes.length ? trainingTypes : [])
        .filter(
          trainingType =>
            (isManager && parseInt(trainingType.is_manager) === 1) || parseInt(trainingType.is_manager) === 0
        )
        .filter(
          trainingType =>
            showEmpty ||
            trainingType.count > 0 ||
            (Array.isArray(trainings) &&
              trainings.some(t => parseInt(t.training_type_id) === parseInt(trainingType.id)))
        )
        .filter(trainingType =>
          trainings.length > 0
            ? trainings.filter(
                training =>
                  parseInt(training.training_type_id) === parseInt(trainingType.id) &&
                  training.training_name.toLowerCase().includes(this.state.inputValue.toLowerCase())
              ).length > 0
            : true
        )
    return (
      <React.Fragment>
        <DashboardLayout>
          <main id='TrainingsPage' className='mainSection'>
            <MDBModal
              className='blocked-access'
              disableBackdrop={true}
              open={parseInt(UserProfileService.getCurrentUserTypeId()) === 91}
              onClose={() => ({})}
            >
              <MDBModalDialog size='fluid'>
                <MDBModalContent>
                  <MDBModalHeader color='danger'>USABG Training Videos</MDBModalHeader>
                  <MDBModalBody>
                    <div>
                      <h4>We know you're excited!</h4>
                      <h5>But you have some steps to complete first ...</h5>
                    </div>
                    <br />
                    <div className='pt-2 pb-5'>
                      Agents must complete contracting requirements before starting training videos. If you feel that
                      your contracting requirements have been met, reach out to your upline for further assistance.
                      <br />
                      <a href={`mailto:${UserProfileService.getUserDetails().upline_email}`}>
                        Email {UserProfileService.getUserDetails().upline_fname}{' '}
                        {UserProfileService.getUserDetails().upline_lname}
                      </a>
                      <br />
                      <a className='btn' href='/welcome'>
                        Back to Onboarding
                      </a>
                    </div>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <MDBModal
              className='training-video-modal'
              disableBackdrop={true}
              open={!!this.state.videoTitle}
              onClose={() => this.#closeVideoModal()}
            >
              <MDBModalDialog size='fluid'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>
                      USABG Training Video
                      <br />
                      <span>{this.state.videoTitle}</span>
                    </MDBModalTitle>
                    <MDBBtn type='button' className='btn-close' color='none' onClick={() => this.#closeVideoModal()} />
                  </MDBModalHeader>
                  <MDBModalBody>
                    {this.state.requires_quiz ? (
                      <MDBRow>
                        <MDBCol size='12' lg='8'>
                          {this.state.videoUrl}
                        </MDBCol>
                        <MDBCol size='12' lg='4' className='mt-4 mt-lg-0'>
                          {this.state.training_quiz_loading ? (
                            <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                              <MDBSpinner></MDBSpinner>
                            </div>
                          ) : (
                            <TrainingQuiz
                              training_quiz={this.state.training_quiz}
                              training_questions={this.state.training_questions}
                              training_answers={this.state.training_answers}
                              onSuccess={() => this.#closeVideoModal()}
                            />
                          )}
                        </MDBCol>
                      </MDBRow>
                    ) : (
                      <div>{this.state.videoUrl}</div>
                    )}
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <MDBModal
              disableBackdrop={true}
              open={this.state.training}
              onClose={() => TrainingsPageService.setEditVideo(false)}
            >
              <MDBModalDialog size='fluid'>
                <MDBModalContent>
                  <MDBModalHeader color='indigo'>
                    {(this.state.training === true ? 'Create new' : 'Update') + ' Training Video'}
                    <MDBBtn
                      type='button'
                      className='btn-close'
                      color='none'
                      onClick={() => TrainingsPageService.setEditVideo(false)}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <TrainingVideoForm training={this.state.training} />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <MDBModal
              disableBackdrop={true}
              open={this.state.trainingType}
              onClose={() => TrainingsPageService.setEditType(false)}
            >
              <MDBModalDialog size='fluid'>
                <MDBModalContent>
                  <MDBModalHeader color='indigo'>
                    {(this.state.trainingType === true ? 'Create new' : 'Update') + ' Training Type'}
                    <MDBBtn
                      type='button'
                      className='btn-close'
                      color='none'
                      onClick={() => TrainingsPageService.setEditType(false)}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <TrainingTypeForm type={this.state.trainingType} />
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <MDBContainer fluid className='mt-5'>
              {loading ? (
                <h2>Loading...</h2>
              ) : (
                <>
                  {outstandingRequired.length ? (
                    <MDBRow>
                      <MDBCol size='12'>
                        <CustomAlert color='warning' className='required-trainings-alert'>
                          <h5>
                            <MDBIcon icon='exclamation-triangle' />
                            &nbsp;Your required trainings are not yet complete.
                          </h5>
                          <p>
                            {`${outstandingRequired.length} required training${
                              outstandingRequired.length === 1 ? ' is' : 's are'
                            } still outstanding and highlighted below. Select one to start it now.`}
                          </p>
                          <ul>
                            {outstandingRequired.map(training => (
                              <li
                                key={`outstanding-required-${training.id}`}
                                onClick={() => this.#openTraining(training)}
                              >
                                <MDBIcon
                                  icon={training?.training_output === 'external_link' ? 'external-link-alt' : 'play'}
                                />
                                &nbsp;{training.training_name}
                              </li>
                            ))}
                          </ul>
                        </CustomAlert>
                      </MDBCol>
                    </MDBRow>
                  ) : (
                    <></>
                  )}
                  <MDBRow className='mb-3'>
                    <MDBCol sm='12' lg='8'>
                      <h2>Trainings</h2>
                      {this.state.canCreate ? (
                        <>
                          <MDBBtn type='button' color='indigo' onClick={this.#createVideo} className='add-new'>
                            <MDBIcon icon='plus' /> Add New Training Video
                          </MDBBtn>
                          <MDBBtn type='button' color='indigo' onClick={this.#createType} className='add-new'>
                            <MDBIcon icon='plus' /> Add New Training Type
                          </MDBBtn>
                        </>
                      ) : (
                        <></>
                      )}
                      <hr />
                      <div className='header-wrapper'>
                        <img src={trainingsHeaderImg} alt='trainings-header-img' />
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: content }}></div>
                    </MDBCol>
                    <MDBCol sm='12' lg='4'>
                      <TrainingValidator
                        userId={UserProfileService.getUserId()}
                        onSuccess={() => this.#refreshCompletions()}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='search-trainings-row'>
                    <MDBCol sm='12' lg='6'>
                      <MDBInput
                        size='lg'
                        label='Search Trainings By Entering Keyword Here'
                        type='search'
                        className='background-color-white'
                        name='trainings_input'
                        value={this.state.inputValue}
                        onChange={e => this.setState({ inputValue: e.target.value })}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    {filteredTrainingTypes.length ? (
                      filteredTrainingTypes.map((trainingType, idx) => (
                        <MDBCol key={`training-list-col-${trainingType.id}-${idx}`} sm='12' lg='6'>
                          <TrainingList
                            key={`training-list-ul-${trainingType.id}-${idx}`}
                            canEdit={this.state.canEdit}
                            type={trainingType}
                            typeId={trainingType.id}
                            inputValue={this.state.inputValue}
                          />
                        </MDBCol>
                      ))
                    ) : (
                      <MDBCol>
                        {!trainingLoading && !trainingTypesLoading ? (
                          <CustomAlert color='info'>
                            <strong>On no</strong>&nbsp;
                            <MDBIcon icon='exclamation' />
                            &nbsp;
                            {`There are no training videos matching the search '${this.state.inputValue}.'`}
                          </CustomAlert>
                        ) : (
                          'Loading ...'
                        )}
                      </MDBCol>
                    )}
                  </MDBRow>
                </>
              )}
            </MDBContainer>
          </main>
        </DashboardLayout>
      </React.Fragment>
    )
  }
}

export default TrainingsPage
